import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import NavBar from '../../components/navbar/NavBar';
import { teacherMenu } from '../../redux/types/menu/menu-action-types';
import { commonRoutes } from '../../constants/routes';
import BannerContainer from '../BannerContainer';
import TeacherFeatureFlagContext, {
  checkClassMissionTrials,
  checkMayPromotion,
  defaultTeacherFeatureFlags
} from './TeacherFeatureFlagContext';
import { getUser } from '../../redux/actions/user-actions';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
  },
  title: {
    flexGrow: 1
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto'
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column'
  },
  fixedHeight: {
    height: 240
  },
  scrollAble: {
    height: 'calc(100vh - 64px)',
    overflowY: 'scroll',
    overflowX: 'hidden'
  }
}));

const TeacherLayout: React.FC<any> = (props: any) => {
  const classes = useStyles();
  const userData = useSelector((state: any) => state.userData);
  const featureFlag = useSelector((state: any) => state.featureFlag);
  const { classes: allClasses } = useSelector((state: any) => state.class);
  const [dashboardVisible, setDashboardVisible] = useState(false);
  const [teacherFeatureFlags, setTeacherFeatureFlags] = useState(
    defaultTeacherFeatureFlags
  );
  const dispatch = useDispatch();
  const { history } = props;

  useEffect(() => {
    dispatch(getUser(userData.token, false));
  }, []);

  useEffect(() => {
    /**
     * Might not be performance, keep tabs on this for now
     */
    setTeacherFeatureFlags(currentFlags => ({
      ...currentFlags,
      isMayPromotionActive: checkMayPromotion(),
      classMissionTrials: checkClassMissionTrials()
    }));
  }, [userData]);

  if (
    (featureFlag.newRegistrationFlow &&
      userData.dreamscape &&
      userData.newRegistrationFlow === 'A') ||
    !featureFlag.newRegistrationFlow
  ) {
    if (!userData.schools.length) {
      history.push(commonRoutes.selectLocation);
      return null;
    } else if (userData.referrer.length === 0) {
      history.push(commonRoutes.updateReferral);
      return null;
    } else if (
      !allClasses.length &&
      !userData.getStarted &&
      userData.abVersion !== 'B'
    ) {
      history.push(commonRoutes.getStarted);
      return null;
    }
    if (!dashboardVisible) {
      setDashboardVisible(true);
    }
  } else {
    if (!dashboardVisible) {
      setDashboardVisible(true);
    }
  }

  return (
    <TeacherFeatureFlagContext.Provider
      value={{
        flags: teacherFeatureFlags,
        updateFlags: setTeacherFeatureFlags
      }}
    >
      {dashboardVisible ? (
        <BannerContainer>
          <div className={classes.root}>
            <NavBar menuType={teacherMenu} />
            <main className={classes.content}>
              <div className={classes.appBarSpacer} />
              <div className={classes.scrollAble}>{props.children}</div>
            </main>
          </div>
        </BannerContainer>
      ) : null}
    </TeacherFeatureFlagContext.Provider>
  );
};

export default withRouter(TeacherLayout);
